import { render, staticRenderFns } from "./page-verify-technical.vue?vue&type=template&id=c86fb814&scoped=true"
import script from "./page-verify-technical.vue?vue&type=script&lang=js"
export * from "./page-verify-technical.vue?vue&type=script&lang=js"
import style0 from "./page-verify-technical.vue?vue&type=style&index=0&id=c86fb814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86fb814",
  null
  
)

export default component.exports